import React from 'react';
import { AppIcon, IconName } from './AppIcon';

// Re-export CustomIcons
export * from './CustomIcons';

// Adapter Pattern: Maintain Heroicons export names but render AppIcon (Lucide)
// This allows migrating visual style without changing every single import in the app immediately.

const createIcon = (name: IconName) => {
    const IconWrapper: React.FC<any> = (props) => <AppIcon name={name} {...props} />;
    IconWrapper.displayName = `AppIcon(${name})`;
    return IconWrapper;
};

export const HomeIcon = createIcon('home');
export const KanbanIcon = createIcon('kanban');
export const ChartIcon = createIcon('chart');
export const UserIcon = createIcon('user');
export const LogoutIcon = createIcon('logout');
export const MessageCircleIcon = createIcon('message');
export const ChatBubbleLeftRightIcon = createIcon('chat');
export const UsersIcon = createIcon('users');
export const CreditCardIcon = createIcon('credit-card');
export const GearIcon = createIcon('settings');
export const CodeIcon = createIcon('code');
export const ArrowLeftIcon = createIcon('arrow-left');
export const UserAvatarIcon = createIcon('avatar');
export const PlusIcon = createIcon('plus');
export const FilterIcon = createIcon('filter');
export const SearchIcon = createIcon('search');
export const XIcon = createIcon('close');
export const MailIcon = createIcon('mail');
export const MoreHorizontalIcon = createIcon('more');
export const CopyIcon = createIcon('copy');
export const InfoIcon = createIcon('info');
export const PencilIcon = createIcon('edit');
export const TrashIcon = createIcon('trash');
export const CheckCircleIcon = createIcon('check-circle');
export const CheckIcon = createIcon('check');
export const CalendarIcon = createIcon('calendar');
export const DownloadIcon = createIcon('download');
export const UploadIcon = createIcon('upload');
export const ListIcon = createIcon('menu');
export const MinusIcon = createIcon('minus');
export const RefreshIcon = createIcon('refresh');
export const CurrencyDollarIcon = createIcon('dollar');
export const BookOpenIcon = createIcon('book');
export const IdentificationIcon = createIcon('id');
export const ClockIcon = createIcon('clock');
export const ArrowRightIcon = createIcon('arrow-right');
export const ProductIcon = createIcon('product');
export const TrackingIcon = createIcon('tracking');
export const CameraIcon = createIcon('camera');
export const LockIcon = createIcon('lock');
export const BellIcon = createIcon('bell');
export const ShieldCheckIcon = createIcon('shield');
export const LifeBuoyIcon = createIcon('life-buoy');
export const HandshakeIcon = createIcon('handshake');
export const HeadsetIcon = createIcon('headset');
export const ChevronDownIcon = createIcon('chevron-down');
export const ChevronUpIcon = createIcon('chevron-up');
export const ChevronLeftIcon = createIcon('chevron-left');
export const ChevronRightIcon = createIcon('chevron-right');
export const ChevronDoubleLeftIcon = createIcon('chevron-double-left');
export const ChevronDoubleRightIcon = createIcon('chevron-double-right');
export const TaskIcon = createIcon('task');
export const PipelineIcon = createIcon('pipeline');
export const PlusCircleIcon = createIcon('plus-circle');
export const DocumentDuplicateIcon = createIcon('duplicate');
export const XCircleIcon = createIcon('x-circle');
export const ArrowPathIcon = createIcon('refresh');

// Componente legado mantido com a nova implementação
export const CheckSquareIcon: React.FC<React.SVGProps<SVGSVGElement> & { isChecked: boolean }> = ({ isChecked, className, ...props }) => {
    // Lucide doesn't have a separate "Solid" set, we simluate "checked" state
    const { name: _unused, ...validProps } = props;
    const sizeClass = className || "w-6 h-6";

    if (isChecked) {
        return <AppIcon name="check-square" className={`text-blue-600 ${sizeClass}`} {...validProps} strokeWidth={3} />;
    }
    return <AppIcon name="check-circle" className={sizeClass} {...validProps} />;
};
